var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container",attrs:{"id":"about"}},[_c('h1',[_vm._v("Experience")]),_c('hr',{staticClass:"my-4 bg-warning",staticStyle:{"height":"3px","border":"none"}}),_c('p',[_vm._v("My experience ...")])])
}]

export { render, staticRenderFns }